// extracted by mini-css-extract-plugin
module.exports = {"info-tooltip":"JiraConfiguration_info-tooltip__yTrGN"};